// @ts-check

import numberWithCommas from "../../../utils/numbersWithComma";

const AMOUNT_VALUES = [500, 1000, 5000, 10000, 50000, 100000, 500000];

/**
 *
 * @param {{onClick:(amnt:number)=>void}} param0
 * @returns {React.ReactNode}
 */
const AmountCard = ({ onClick }) => {
  return AMOUNT_VALUES.map((amnt, idx) => (
    <li key={idx} onClick={() => onClick(amnt)}>
      {numberWithCommas(amnt)}
    </li>
  ));
};

export default AmountCard;
